// Centralize API/base URL handling for Netlify/static deployments
// Usage:
//   import { apiUrl, fileUrl } from './api';
//   fetch(apiUrl('/api/cars'))
//   <img src={fileUrl(`/uploads/${name}`)} />

const BASE = process.env.REACT_APP_API_BASE || '';

function join(base, path) {
  if (!path) return base || '';
  if (/^https?:\/\//i.test(path)) return path; // already absolute
  if (!base) return path;
  if (base.endsWith('/') && path.startsWith('/')) return base + path.slice(1);
  if (!base.endsWith('/') && !path.startsWith('/')) return base + '/' + path;
  return base + path;
}

export function apiUrl(path) {
  return join(BASE, path);
}

export function fileUrl(path) {
  return join(BASE, path);
}

// Helper to handle both legacy local paths and new R2 URLs
export function imageUrl(path) {
  if (!path) return '';
  // If already a full URL (R2), return as-is
  if (/^https?:\/\//i.test(path)) return path;
  // Legacy local path: prefix with /uploads/
  return fileUrl(`/uploads/${path}`);
}

export const API_BASE = BASE;
